import { createSlice } from "@reduxjs/toolkit";

export const dataCartSlice = createSlice(
    {
        name: 'Count Cart',
        initialState: {
            countCart: 0,
            dataCart: [],
            cash: 'bank',
            paymentInfo: {}

        },
        reducers: {
            setCountCart: (state, action) => {
                state.countCart = action.payload
            },
            setDataCart: (state, action) => {
                state.dataCart = action.payload
            },
            setCartCashPayment: (state, action) => {
                state.cash = action.payload
            },
            setInfoPayment: (state, action) => {
                state.paymentInfo = action.payload
            }
        }

    }
)
export const dataCartReducer = dataCartSlice.reducer
export const dataCartAction = dataCartSlice.actions
export const dataCartInfo = (state) => state.dataCartReducer
export default dataCartReducer

